import { ROUTES } from '@/lib/constants';
import { createMemoryRouter, Navigate } from 'react-router';
import React, { useMemo } from 'react';
import lazyRetry from './lib/helpers/lazyRetry';
import { useSelector } from 'react-redux';
import { RootState } from '@/store/store';
import { selectMemberProfile } from '@/state/member/memberSelectors';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
// import GlobalContext from '@/context/GlobalContext';
// Lazy-loaded components and pages
const NotFound = lazyRetry(() => import('./pages/404'), 'notFound');
const HypertrackerLayout = lazyRetry(
    () => import('./components/Hypertracker/Layout'),
    'hypertrackerLayout',
);
const HypertrackerPerps = lazyRetry(() => import('./pages/HypertrackerPerps'), 'hypertrackerPerps');

const useAppRouter = () => {
    const member = useSelector((state: RootState) => selectMemberProfile(state));
    const theme = useTheme();
    const isTabletScreen = useMediaQuery(theme.breakpoints.down('md'));
    const defineNavigate = () => {
        return <Navigate to={ROUTES.HYPERTRACKER} />;
    };

    const routes = useMemo(() => {
        return [
            {
                path: ROUTES.HYPERTRACKER,
                element: <HypertrackerLayout />,
                children: [
                    { path: '', element: <HypertrackerPerps /> },
                    { path: '*', element: <NotFound /> },
                ],
            },
        ];
    }, [defineNavigate]);

    return useMemo(() => {
        return createMemoryRouter(routes, { initialEntries: [ROUTES.HYPERTRACKER] });
    }, [member, routes]);
};

export default useAppRouter;
